export const USER_STATES = {
  1: "Active",
  0: "Inactive",
};

export const EQUIPMENT_OPTIONS = [
  { value: "Light Weight", label: "Light Weight" },
  { value: "Light Weights", label: "Light Weights" },
  { value: "Moderate Weight", label: "Moderate Weight" },
  { value: "Moderate Weights", label: "Moderate Weights" },
  { value: "Heavy Weight", label: "Heavy Weight" },
  { value: "Heavy Weights", label: "Heavy Weights" },
  { value: "Light Band", label: "Light Band" },
  { value: "Moderate Band", label: "Moderate Band" },
  { value: "Elevated Surface", label: "Elevated Surface" },
  { value: "Barbell+Rack", label: "Barbell+Rack" },
  { value: "3 Cones", label: "3 Cones" },
  { value: "4 Cones", label: "4 Cones" },
  { value: "Ball", label: "Ball" },
  { value: "Wall", label: "Wall" },
  { value: "Dumbbell", label: "Dumbbell" },
  { value: "Kettlebell", label: "Kettlebell" },
  { value: "Resistance Band", label: "Resistance Band" },
  { value: "Cones", label: "Cones" },
];

export const USER_STATE_OPTIONS = [
  { value: 1, label: "Active" },
  { value: 2, label: "Inactive" },
];

export const CMS_VIDEO_STATE_OPTIONS = [
  { value: 1, label: "Pending" },
  { value: 2, label: "Processing" },
  { value: 3, label: "Error" },
  { value: 4, label: "Active" },
  { value: 5, label: "Inactive" },
];

export const getVideoStateLabelByValue = (value) => {
  let label = "";

  //loop thru objects in data
  CMS_VIDEO_STATE_OPTIONS.forEach(function (itm) {
    if (itm.value === value) {
      label = itm.label;
    }
  });

  return label;
};

export const CMS_IMAGE_STATE_OPTIONS = [
  // { value: 1, label: 'Pending' },
  // { value: 2, label: 'Processing' },
  // { value: 3, label: 'Error' },
  { value: 4, label: "Active" },
  { value: 5, label: "Inactive" },
];

export const getImageStateLabelByValue = (value) => {
  let label = "";

  //loop thru objects in data
  CMS_IMAGE_STATE_OPTIONS.forEach(function (itm) {
    if (itm.value === value) {
      label = itm.label;
    }
  });

  return label;
};

export const USER_TRAIL_STATUS_OPTIONS = [
  { value: "paid", label: "Paid" },
  { value: "unpaid", label: "Unpaid" },
];

export const USER_TRAIL_STATUS_WITH_EMPTY_OPTIONS = [
  { value: "", label: "Please select" },
  { value: "paid", label: "Paid" },
  { value: "unpaid", label: "Unpaid" },
];
export const USER_TRAIL_STATUS = {
  paid: "Paid",
  unpaid: "Unpaid",
};

export const USER_TRAIL_STATUS_LIST_OPTIONS = [
  { value: "", label: "All" },
  { value: "paid", label: "Paid" },
  { value: "unpaid", label: "Unpaid" },
];

export const USER_STATUS_LIST_OPTIONS = [
  { value: "active,invited", label: "All" },
  { value: "active", label: "Active" },
  { value: "invited", label: "Invited" },
];

export const ACTIVITIES_LIST_OPTIONS = [
  { value: "", label: "All" },
  { value: "activity", label: "Activity" },
  { value: "movement", label: "Movement" },
  { value: "breathwork", label: "Breathwork" },
  { value: "excercise", label: "Excercise" },
];

export const RESOURCETYPE_LIST_OPTIONS = [
  { value: "", label: "All" },
  { value: "Brain Health", label: "Brain Health" },
  { value: "Mental Health", label: "Mental Health" },
  { value: "Concussion", label: "Concussion" },
];

export const USER_CREATED_LIST_OPTIONS = [
  { value: 30, label: "Last Month" },
  { value: 30 * 3, label: "Last 3 Months" },
  { value: 30 * 6, label: "Last 6 Months" },
  { value: 368, label: "Last Year" },
  { value: 368 * 2, label: "Last 2 Years" },
  { value: 368 * 3, label: "Last 3 Years" },
  { value: 1_000_000, label: "All" },
];

export const PAGE_SIZE_OPTIONS = [
  { value: 2, label: "2 Rows" },
  { value: 5, label: "5 Rows" },
  { value: 10, label: "10 Rows" },
  { value: 25, label: "25 Rows" },
  { value: 50, label: "50 Rows" },
  { value: 100, label: "100 Rows" },
  { value: 250, label: "250 Rows" },
];

export const BREATHWORK_TYPE_OPTIONS = [
  // https://github.com/Rhea-Health/rhea-core/blob/2c01546fcd3cb5c408c4c3bb7ecc365028205b8f/models/session_models.go#L18
  { value: "coherant", label: "Coherent Breathing" },
  { value: "alternate_nostril", label: "Alternate Nostril Breathing" },
  { value: "478_breathing", label: "4-7-8 Breathing" },
  { value: "-", label: "Unknown Breathing Exercise" },
];

export const BREATHWORK_TYPE_WITH_EMPTY_OPTIONS = [
  { value: "", label: "Please select" }, // EMPTY OPTION
  ...BREATHWORK_TYPE_OPTIONS,
];

export const USER_ACTIVITY_FEELING_OPTIONS = [
  { value: "paid", label: "Paid" },
  { value: "unpaid", label: "Unpaid" },
];

export const USER_ACTIVITY_FEELING_WITH_EMPTY_OPTIONS = [
  { value: "", label: "Please select" },
  { value: "positive", label: "Positive" },
  { value: "neutral", label: "Neutral" },
  { value: "negative", label: "Negative" },
];

export const USER_ACTIVITY_FEELING = {
  positive: "Positive",
  neutral: "Neutral",
  negative: "Negative",
};

export const USER_ACTIVITY_FEELING_LIST_OPTIONS = [
  { value: "", label: "All" },
  { value: "positive", label: "Positive" },
  { value: "neutral", label: "Neutral" },
  { value: "negative", label: "Negative" },
];

export const USER_SORT_OPTIONS = [
  { value: "last_name,ASC", label: "Last Name (Asc)" },
  { value: "last_name,DESC", label: "Last Name (Desc)" },
  { value: "created,ASC", label: "Created (Asc)" },
  { value: "created,DESC", label: "Created (Desc)" },
];

export const SESSION_TEMPLATE_SORT_OPTIONS = [
  { value: "completed_time,ASC", label: "Completed (Asc)" },
  { value: "completed_time,DESC", label: "Completed (Desc)" },
];

export const SESSION_TEMPLATE_SESSION_TYPE_OPTIONS = [
  { value: "base", label: "Base" },
  { value: "sleep", label: "Sleep" },
  { value: "breath", label: "Breath" },
];

export const SESSION_TEMPLATE_SESSION_TYPE_WITH_EMPTY_OPTIONS = [
  { value: "", label: "Please select" }, // EMPTY OPTION
  ...SESSION_TEMPLATE_SESSION_TYPE_OPTIONS,
];

export const USER_REPORT_SORT_OPTIONS = [
  { value: "created,ASC", label: "Created (Asc)" },
  { value: "created,DESC", label: "Created (Desc)" },
];
